import { setUserTypeInLS } from './UserTypeHandler';
import { mixpanelObject } from '../analytics';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_LOGOUT
} from '../analytics/mixpanel/mixpanelConstants';
import {
  logoutEvent,
  clearSuperProperty,
  timeEvent
} from '../analytics/mixpanel/mixpanelEventsHelper';
import { UserTypes } from '../constants/stringConstants';

const trackLogoutEvent = () => {
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_LOGOUT);
  logoutEvent();
  clearSuperProperty();
  timeEvent();
};

/**
 * Logout Fn: Is called from 2 places.
 * 1. B2B user. It is required to clear any previous active token user might have.
 * 2. When user actually logout's from the platform. Clearing all the storage.
 *
 * Pending: Google account check is pending. Need to confirm if we are still using Gpay SDK.
 */
export const logout = () => {
  if (navigator.credentials && navigator.credentials.preventSilentAccess) {
    navigator.credentials.preventSilentAccess();
  }

  localStorage.clear();
  sessionStorage.clear();

  setUserTypeInLS(UserTypes.GUEST);
  trackLogoutEvent();
};
